export default function Hero() {
  return (
    <section
      id="home"
      className="
        relative bg-gradient-to-b from-[#FAFAFA] to-[#E9E3D5] text-center 
        flex flex-col items-center justify-center 
        min-h-[30vh] sm:min-h-[38vh] md:min-h-[60vh] 
        font-[Montserrat] px-4
      "
    >
      {/* Judul utama */}
      <h1
        className="
          text-2xl sm:text-[0.9rem] md:text-6xl 
          font-extrabold text-[#1C1C1C] 
          leading-tight sm:leading-[1.1rem] md:leading-tight 
          mb-1 sm:mb-[2px] drop-shadow-sm
        "
      >
        Beyond Structures
      </h1>

      <h2
        className="
          text-xl sm:text-[0.85rem] md:text-5xl 
          font-extrabold text-[#8D0801] italic 
          leading-tight sm:leading-[1rem] md:leading-tight 
          mb-4 sm:mb-[3px] drop-shadow-sm
        "
      >
        We Build Integrity
      </h2>

      {/* Subjudul */}
      <p
        className="
          text-xs sm:text-[0.55rem] md:text-base 
          text-[#2E2E2E] font-[Lato] 
          mb-8 sm:mb-[6px] tracking-wide 
          max-w-md sm:max-w-[220px] md:max-w-xl
        "
      >
        Dedication Built Into Every Project
      </p>

      {/* Tombol */}
<a
  href="#contact"
  className="
    bg-[#8D0801] text-white font-semibold 
    text-xs sm:text-[0.25rem] md:text-base 
    px-4 sm:px-[3px] md:px-8 
    py-2 sm:py-[1px] md:py-3 
    rounded-full sm:rounded-[8px] md:rounded-full 
    shadow-md hover:bg-[#5E0909] transition-all duration-300 
    transform hover:scale-105 hover:shadow-lg
  "
>
  CONTACT US
</a>


      {/* Efek dekoratif bawah */}
      <div className="absolute bottom-0 w-full h-[4px] bg-[#1C3A4D]"></div>
    </section>
  );
}
